export enum PatternListScrollViewportConstants {
  ITEM_SIZE = '62',
  MIN_BUFFER_SIZE = '1240', // 20 element
  MAX_BUFFER_SIZE = '12400' // 200 element
}


